const firebaseConfig = {
    apiKey: "AIzaSyDvEW4VxTAwHkAcJow9dp8OZSjgmSJ8huU",
    authDomain: "volunteer-webbing.firebaseapp.com",
    databaseURL: "https://volunteer-webbing.firebaseio.com",
    projectId: "volunteer-webbing",
    storageBucket: "volunteer-webbing.appspot.com",
    messagingSenderId: "230569300970",
    appId: "1:230569300970:web:3bbd3195fbce301281d893"
  };

  export default firebaseConfig;